import type { RouteLocationRaw, RouteRecordRaw } from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getSignUpRouteRecord():RouteRecordRaw{
  return {
    name: 'sign_up',
    path: '/sign-up',
    component: customAsyncComponent(async () => import('./views/SignUpView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.SIGN_UP,
        LOCALE_CATEGORIES.SIGN_IN,
        LOCALE_CATEGORIES.ERRORS,
      ]
    },
  }
}

export function getSignUpRouteLocation():RouteLocationRaw{
  return { name: 'sign_up' }
}